import { memo } from "react";
import { Cell } from "@tanstack/react-table";

import Accordion from "../Accordion/Accordion";
import { ArrawDownIcon } from "../icons";
import TableCellContent from "./components/TableCell/TableCellContent";
import TableCellMobileValue from "./components/TableCell/TableCellMobileValue";
import { TableCellValue, TableData, TableMetrics } from "./types";

import styles from "./Table.module.css";

type TableMobileProps = {
  rows: Array<{ id: string; getVisibleCells: () => Cell<TableData, unknown>[] }>;
  onOpenResponse: (responseId: string, metrics?: TableMetrics) => void;
};

function getBrandColumnIndex(columnId: string): number {
  const match = columnId.match(/^brand_group_(\d+)$/);
  return match ? Number(match[1]) : -1;
}

function isTitleColumn(columnId: string): boolean {
  return columnId === "models" || columnId === "prompts";
}

const TableMobile = memo(function TableMobile({
  rows,
  onOpenResponse,
}: TableMobileProps) {
  return (
    <div className={styles["table__mobile"]}>
      {rows.map((row) => {
        const cells = row.getVisibleCells();
        const titleCell = cells.find((c) => isTitleColumn(c.column.id)) ?? null;

        const brandCells = cells
          .filter((c) => getBrandColumnIndex(c.column.id) !== -1)
          .sort((a, b) => getBrandColumnIndex(a.column.id) - getBrandColumnIndex(b.column.id));

        return (
          <div key={row.id} className={styles["table__mobile-item"]}>
            <Accordion
              classNameContainer={styles["table__mobile-accordion"]}
              classNameContent={styles["table__mobile-accordion-content"]}
              header={(isOpen, setIsOpen) => (
                <div
                  className={styles["table__mobile-accordion-header"]}
                  onClick={(e) => {
                    const target = e.target as HTMLElement | null;
                    if (target?.closest("a")) return;
                    setIsOpen(!isOpen);
                  }}
                >
                  <div className={styles["table__mobile-accordion-title"]}>
                    {titleCell ? (
                      <TableCellContent
                        columnId={titleCell.column.id}
                        value={(titleCell.getValue() as TableCellValue) || null}
                        onOpenResponse={onOpenResponse}
                      />
                    ) : null}
                  </div>
                  <button
                    type="button"
                    className={styles["table__mobile-accordion-toggle"]}
                    aria-label={isOpen ? "Свернуть" : "Развернуть"}
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <ArrawDownIcon
                      className={styles["table__mobile-accordion-icon"]}
                      data-open={isOpen ? "true" : "false"}
                    />
                  </button>
                </div>
              )}
              content={() => (
                <div className={styles["table__mobile-accordion-body"]}>
                  {brandCells.map((cell) => {
                    const brandName = cell.column.columnDef.header as unknown as React.ReactNode;
                    return (
                      <div key={cell.id} className={styles["table__mobile-row"]}>
                        <div className={styles["table__mobile-row-values"]}>
                          <div className={styles["table__mobile-brand-title"]}>{brandName}</div>
                          <TableCellMobileValue
                            value={(cell.getValue() as TableCellValue) || null}
                            onOpenResponse={onOpenResponse}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            />
          </div>
        );
      })}
    </div>
  );
});

export default TableMobile;

